import Sentry from 'sentry';

global.PHTH = {
    age: 0,
    branch: 'phth',
    // dry-run marker:
    dry: true,
    o_possible: true,
    type: 'phth',
    plus: false,
    canCalc: function(e) {
	PHTH.o_possible = PHTH.haveRisk(e) && PHTH.havePeril(e);
	BC.debug('PHTH.canCalc():', PHTH.o_possible, 64);
	PRIV.calcable = PHTH.o_possible;
	return PHTH.o_possible;
    },

    change: function(e) {
    	// plus IF /p/phv OR phth-ph selected AND the premium plus button THAT IS CHECKED (:checked) has value 1
		PHTH.plus = (JQ('#f_phth-ph').is(':checked') || ALL.mobile && JQ("#fset_phth-ph_risk").length)
			&& JQ('input[name="phth-ph_premium-plus"]:checked').val() === '1';

        if (PHTH.plus) {
            JQ('#a_da_wording').attr('href', '/TR/dl4/B-Haftpflicht-PremiumPlus-20210601.pdf');
        } else {
            JQ('#a_da_wording').attr('href', '/TR/dl4/B-Haftpflicht-Premium-20210601.pdf');
        }

		if (!JQ('#f_phth-th').is(':checked')) {
			JQ('#f_phth_sb_0').prop('checked', true);
			JQ('#f_phth_sb_1').prop('checked', false);
		}

		if (JQ(e.target).attr('id') === 'f_phth-ph_rbt_bundle' || JQ(e.target).attr('id') === 'f_phth-ph_rbt_bundle_text') {
			PHTH.type = 'phth-ph'
		} else {
			PHTH.type = e ? PRIV.get_branch(e) : PRIV.get_branch(this);
			if (PHTH.type == 'rbt') PHTH.type = 'phth';
			if (PRIV.get_branch(this) === 'phth1') PHTH.type = 'phth1';
			if (PHTH.type.indexOf('-') > 0) PHTH.branch = PHTH.type.split('-')[0];
		}
		BC.debug('PHTH.change()', PHTH.type, 64);
			var b = JQ('#div_' + PHTH.type + '_rslt').length ? PHTH.type : PHTH.branch;
		if (ALL.chkChkBox('#f_phth_dnls')) {
				var endFieldId = '#f_' + PHTH.type + '_ende';
				if (PHTH.type.startsWith('phth-')) {
					endFieldId = '#f_' + PHTH.branch + '_ende'
				}
				ALL.chkDate(JQ(endFieldId));
			}
		if (! PHTH.canCalc(e)) {
			ALL.chgProduct(b, null);
		} else {
			JQ('#b_' + b + '_go2datavn').button("option", "disabled", ! PHTH.o_possible);
			PHTH.recalc();
		}
		if (parseInt(JQ('#f_'+PHTH.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+PHTH.type+'_rbt_bundle_text').val().length === 0) {
			JQ('#vs-nr-hint-' + PHTH.type).show();
			JQ('#b_' + b + '_go2datavn').button("option", "disabled", true);
		} else {
			JQ('#b_' + b + '_go2datavn').button("option", "disabled", false);
			JQ('#vs-nr-hint-' + PHTH.type).hide();
		}
		ALL.notifyHeight();
    },

    chkDivComplete: function() {
        if (! PHTH.chkDivReady(this)) {
            BC.debug('PHTH.chkDivComplete called by ', BC.get_id(this), 64);
        }
    },

    chkDivReady: function(btn) {
	var r;
        BC.debug('PHTH.chkDivReady():', btn, 64);
	try {
	    var b = BC.get_id(btn);
            var p = ALL.get_box_id(b);
            if (! p) return false;
	    var d = BC.get_id(p);
            PHTH.age = parseInt(JQ('#f_phth-ph_age').val());
	}
	catch (e) {
	    BC.debug('PHTH.chkDivReady() rised an exception:', e, 16);
		Sentry.captureException(e);
	    return false;
	}
        if (! d) return false;
	BC.debug('PHTH.chkDivReady() called for ' + b + ' in ' + d, btn, 64);
        ALL.chkDivReady(d, true);
	switch(d) {
	case '#div_0':
	    return true;
	case '#div_1':
            if (PHTH.age && PHTH.age < 18) {
                BC.debug('PHTH.chkDivReady(): AGE ' + PHTH.age + ' not allowed!', '', 64);
	    } else if (PHTH.age &&
		(JQ('#f_phth-ph_typ_4').is(':checked') ||
                 JQ('#f_phth-ph_typ_2').is(':checked') ||
                 JQ('#f_phth-ph_typ_3').is(':checked') ||
                 JQ('#f_phth-ph_typ_1').is(':checked'))) {
		BC.debug('PHTH.chkDivReady(): ' + d + ' is ready!', '', 64);
		return true;
	    }
	    ALL.chgMobButton('#btn_fwd_1', false);
	    break;
        case '#div_2':
	    if ((JQ('#f_phth-ph_vs_10').is(':checked') ||
                 JQ('#f_phth-ph_vs_20').is(':checked') ||
                 JQ('#f_phth-ph_vs_50p').is(':checked')) ) {
		BC.debug('PHTH.chkDivReady(): ' + d + ' is ready!', '', 64);
		ALL.steps[1] = 3;
			if (parseInt(JQ('#f_'+PHTH.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+PHTH.type+'_rbt_bundle_text').val().length === 0) {
				JQ('#vs-nr-hint-phth-ph').show();
				ALL.chgMobButton('#btn_fwd_3', false);
			} else {
				JQ('#vs-nr-hint-phth-ph').hide();
				return true;
			}
	    }
	    ALL.chgMobButton('#btn_fwd_2', false);
	    break;
        case '#div_3':
	    if (ALL.isVNcompleted() && ALL.haveVN()) {
		BC.debug('PHTH.chkDivReady(): ' + d + ' is ready!', '', 64);
		// It's time to fetch an offer-ID:
		// (but only if btn_fwd_4 is pressed)
		// Disabled on 2018-11-19: We now use submit to /TR/anda,
		// no need to prefetch an offer-ID
		if (b.slice(0, 4) == '#btn') PRIV.get_onr();
		return true;
	    }
	    break;
        case '#div_4':
            PHTH.setChkFlds();
	    r = PRIV.chkDA0();
	    BC.debug('PHTH.chkDivReady(): #div_4 ready is', r, 64);
	    if (r) return true;
	    BC.debug('PHTH.chkDivReady(): #div_4 is NOT ready!', '', 64);
            break;
	case '#div_98':
	    return true;
	case '#div_99':
            JQ('#div_'  +  HARA.type + '_rslt').hide();
		ALL.triggerDataLayerEvent('Haftpflicht', PHTH.type);
	    return true;
	default:
	    BC.debug('PHTH.chkDivReady() switch to default, BAD THING [tm]:', d, 16);
	    break;
	}
	BC.debug('PHTH.chkDivReady(): ' + d + ' is NOT ready!', '', 64);
	return false;
    },

    chkKeys: function(e) {
	var age = JQ('#f_' + PHTH.type + '_age').val();
	BC.debug('PHTH.chkKeys(): key pressed: ' + e.key +
		  ' age.len=' + age.length, '', 64);
	try {
	    PHTH.age = parseInt(age);
	}
	catch(e) {
	    BC.debug('PHTH.chkKeys(): raised exception:', e, 64);
	    PHTH.age = 0;
	}
	if (! isNaN(PHTH.age) && PHTH.age >= 18 && PHTH.age <= 110) {
	    BC.debug('PHTH.chkKeys(): 1st calc is possible!', '', 64);
	    ALL.chgMobButton('#btn_fwd_1', true);
	    PHTH.change(this);
	    return;
	} else if (age.length > 1) {
            ALL.showHint('Ein Versicherungsabschluss ist erst ab 18 Jahren möglich.');
        }
	ALL.chgMobButton('#btn_fwd_1', false);
    },

    havePeril: function(e) {
	BC.debug('PHTH.havePeril(): Checking for type ' + PHTH.type + ' branch ' + PHTH.branch, '', 64);
	var valid = false;
        var _type = '';
        var b = JQ('#div_' + PHTH.type + '_rslt').length ? PHTH.type : PHTH.branch;
	PRIV.bparts[b] = [];
	if (
	     JQ('#f_phth-ph').is(':checked') &&
	     JQ("#div_phth-ph input[name=phth-ph_typ]").is(':checked')) {
	    // PHV: Alle Angaben vorhanden
	    BC.debug('PHTH.havePeril(): ' + PHTH.type + ' is valid!', '', 64);
	    valid = true;
	    if (JQ('#f_phth-ph_vs_50p').is(':checked')) {
		BC.debug('PHTH.havePeril(): PLUS-variant checked', PHTH.type, 64);
	    }
	} else if (ALL.mobile && JQ("input[name=phth-ph_typ]").is(':checked')) {
	    // Mobile PHV: Alle Angaben vorhanden
	    BC.debug('PHTH.havePeril(): ' + PHTH.type + ' is valid!', '', 64);
	    valid = true;
	    if (JQ('#f_phth-ph_vs_50p').is(':checked')) {
		BC.debug('PHTH.havePeril(): PLUS-variant checked', PHTH.type, 64);
	    }
        }
	if (b == 'phth1' &&
	    JQ("#f_" + b + "-ph").is(':checked') &&
	    JQ("#div_" + b + "-ph input[name='" + b + "-ph_typ']").is(':checked') &&
	    JQ('#f_' + b + '_sk').val() == '1') {
	    // PHV-Sonderkonzept: Alle Angaben vorhanden
	    PRIV.bparts[b].push('ph');
	    valid = true;
	}
	if (JQ("#f_" + b + "-th").is(':checked') &&
	    JQ('#f_' + b + '_sk').val() == '1' &&
	    PRIV.bparts[b].indexOf('th') < 0) {
	    PRIV.bparts[b].push('th');
	}
	JQ('.display-on-esg_' + b).hide();
	if (JQ("#f_" + b + "_esg").is(':checked') && JQ('#f_' + b + '_esg').val() == '1' && PRIV.bparts[b].indexOf('esg') < 0) {
	    PRIV.bparts[b].push('esg');
        JQ('.display-on-esg_' + b).show();
	}
	if (JQ("#f_" + b + "-th").is(':checked') &&
	    ! parseInt(JQ("#f_" + b + "-th_hu").val())) {
	    JQ('#f_' + b + '-th_hu').val(1);
	    valid = true;
	} else if (! valid && JQ("#f_" + b + "-th").is(':checked') &&
	    parseInt(JQ("#f_" + b + "-th_hu").val())) {
	    // THV: Alle Angaben vorhanden
	    valid = true;
	} else if (! JQ("#f_" + b + "-th").is(':checked')) {
	    JQ('#f_' + b + '-th_hu').val(0);
	    JQ('#f_' + b + '-th_net2').text('0,00 €');
	}
	if (! valid && JQ("#f_" + b + "-hh").is(':checked') &&
	    JQ("#div_" + b + "-hh input[name='" + b + "-hh_typ']").is(':checked') &&
	    JQ("#div_" + b + "-hh input[name='" + b + "-hh_plz']").val() &&
	    JQ("#div_" + b + "-hh select[name='" + b + "-hh_ort']").val() &&
	    JQ("#div_" + b + "-hh select[name='" + b + "-hh_str']").val() &&
	    JQ("#div_" + b + "-hh select[name='" + b + "-hh_hnr']").val() &&
		JQ("#div_" + b + "-hh input[name='" + b + "-hh_gg']").val()
	) {
	    // Haus-/Grundbesitzerhaftpflicht: Alle Angaben vorhanden und hnr vorhanden
		valid = true;
	}
	if (! valid && JQ("#f_" + b + "-wh").is(':checked') &&
	    JQ("#div_" + b + "-wh input[name='" + b + "-wh_typ']").is(':checked')) {
	    // Gewässerschadenhaftpflicht: Alle Angaben vorhanden
	    valid = true;
	}
	if (! valid && JQ("#f_" + b + "_bh").is(':checked') &&
	    JQ("#div_" + b + "_bh input[name='" + b + "_bhvs']").is(':checked') &&
	    JQ("#div_" + b + "_bh input[name='" + b + "_bh_ep']").is(':checked') &&
	    parseInt(JQ("#f_" + b + "_bh_bs").val())) {
	    // Bauherrenhaftpflicht: Alle Angaben vorhanden
	    valid = true;
	}
	if (! valid && ! PHTH.dry) {
	    ALL.showHint('Haftpflicht: Bitte mindestens eine Haftpflicht-Deckung auswählen!', 1);
	    BC.debug('PHTH.havePeril(): Missing phth_risk', null, 64);
	}
	JQ.each(['ph', 'th', 'hh', 'wh', 'bh'], function(i, v) {
            _type = PHTH.type + '_' + v;
            if (! JQ('#f_' + _type).length) _type = PHTH.type + '-' + v;
            if (! JQ('#f_' + _type).length) _type = PHTH.branch + '-' + v;
	    if (JQ('#f_' + _type).is(':checked')) {
		JQ('#div_' + _type + '_1').show();
		if (PHTH.plus) {
		    PRIV.bparts[b].push('ph%2B');
		} else {
		    PRIV.bparts[b].push(v);
		}
	    } else {
		JQ('#r_' + _type + '_net2').text('0,00 €');
		JQ('#div_' + _type + '_1').hide();
	    }
	});
	BC.debug('PHTH.havePeril():', valid, 128);
	ALL.notifyHeight();
	return valid;
    },

    haveRisk: function(e) {
		BC.debug('PHTH.haveRisk(): Checking ...', e, 256);
		// valid = true : Alle Risikomerkmale vorhanden
		var valid = true;
        var b = JQ('#div_' + PHTH.type + '_rslt').length ? PHTH.type : PHTH.branch;

		if (JQ("input[name='" + b + "_sb']").length &&
				! JQ("input[name='" + b + "_sb']").is(':checked')) {
			if (! PHTH.dry) {
			ALL.showHint('Haftpflicht: Bitte auswählen, ob eine Selbstbeteiligung vereinbart werden soll.', 1);
			BC.debug('PHTH.haveRisk(): Missing phth_sb', null, 64);
			}
			valid = false;
		}

		if (ALL.mobile && JQ('#f_' + b + '_age').val() < 18 || ALL.mobile && PHTH.age < 18) {
			valid = false;
		}

		BC.debug('PHTH.haveRisk() for ' + b + ' returns ', valid, 64);
		return valid;
    },

    init: function() {
        PRIV.hideLogoutAndAdministration();
		PRIV.createBundleRabattFieldsForBranch('phth-ph')
		PRIV.createBundleRabattFieldsForBranch('phth1')
		BC.debug('PHTH.init() for', PHTH.type, 64);
		if (isEsg && isEsg === 1) {
			JQ('#f_phth_esg').prop('checked', true);
			JQ('#f_phth1_esg').prop('checked', true);
			JQ('#f_phth-ph_esg').prop('checked', true);
		}
        JQ('#div_phth_vers').change(PHTH.change);
        JQ('#div_phth-ph_vers').change(PHTH.change);
        JQ('#div_phth1_vers').change(PHTH.change);
		PHTH.plus = JQ('#f_phth-ph').is(':checked') && JQ('input[name="phth-ph_premium-plus"]').val() === '1';
		if (! ALL.mobile) {
            ALL.chgProduct('phth', null);
            ALL.chgProduct('phth1', null);
            return;
		} else if (! JQ('#div_phth-ph_vers').length) {
            return;
        }

		PHTH.type = JQ('#f_phth-ph').val() == '1' ? 'phth-ph' : JQ('#f_branch').val();
		ALL.chgProduct(PHTH.type, null);
		ALL.chgMobButton('#btn_fwd_1', false);

		JQ('#f_' + PHTH.type + '_age').keyup(PHTH.chkKeys);
		JQ('.box input').keyup(ALL.chkDivReady2);
		if (JQ('#f' + PHTH.type + '__dnls').length &&
			JQ('#f' + PHTH.type + '__dnls').is(':checked')) JQ('#f_' + PHTH.type + '_ende').val(in3year);
		JQ('#a_da_wording').click(function() {
			PRIV.wd_read=true;
			ALL.chkDivReady('a_da_wording', true);
			ALL.chgMobButtons(ALL.branch);
		});
		ALL.notifyHeight();
	},

    recalc: function(e) {
	BC.debug('PHTH.recalc():', '', 256);
	if (! PHTH.canCalc()) {
	    BC.debug('PHTH.recalc():', 'Cannot calc - check logs!', 16);
	    return;
	}

	var sa = PHTH.type === 'phth1' ? PRIV.make_sa('phth1') : PRIV.make_sa('phth-ph');

	BC.debug('PHTH.recalc():', sa, 64);
	JQ.getJSON(JSONURI, sa, PHTH.setPremium);
	ALL.chkContactData();
	ALL.notifyHeight();
    },

    reset: function() {
	BC.debug('PHTH.reset()', '...starting...', 256);
	PHTH.change();
    },

    setChkFlds: function () {
	// Belege Felder in "Angaben überprüfen"
	// Aufruf teilweise in ALL.set_HNR
	if (ALL.mobile) {
            JQ('#m098_age').text(JQ('#f_phth-ph_age').val());
            if (JQ('#f_phth-ph_typ_4').is(':checked')) {
                JQ('#m098_situation').text('Single ohne Kind/er');
            } else if (JQ('#f_phth-ph_typ_2').is(':checked')) {
                JQ('#m098_situation').text('Single mit Kind/er');
            } else if (JQ('#f_phth-ph_typ_3').is(':checked')) {
                JQ('#m098_situation').text('Paar ohne Kind/er');
            } else if (JQ('#f_phth-ph_typ_1').is(':checked')) {
                JQ('#m098_situation').text('Familie');
            }
            if (JQ('#f_phth-ph_vs_10').is(':checked')) {
                JQ('#m098_vs').text('10 Millionen');
            } else if (JQ('#f_phth-ph_vs_20').is(':checked')) {
                JQ('#m098_vs').text('20 Millionen');
            } else if (JQ('#f_phth-ph_vs_50p').is(':checked')) {
                JQ('#m098_vs').text('50 Millionen');
            }
            JQ('#m098_le').text(JQ('#f_phth-ph_le').val() == '1' ? 'Ja' : 'Nein');

            var selbstbeteiligungValue = JQ('#f_phth-ph_sb').val();

            if (selbstbeteiligungValue === '0') {
				JQ('#m098_sb').text('Selbstbeteiligung 0,00 €');
			}

            if (selbstbeteiligungValue === '1') {
				JQ('#m098_sb').text('Selbstbeteiligung 250,00 €');
			}

            if (selbstbeteiligungValue === '2') {
				JQ('#m098_sb').text('Selbstbeteiligung 500,00 €');
			}

            if (selbstbeteiligungValue === '3') {
				JQ('#m098_sb').text('Selbstbeteiligung 1000,00 €');
			}

            if (JQ('#f_phth-ph_phv-premium').is(':checked')) {
				JQ('#m098_tarif').text('Premium');
			}

            if (JQ('#f_phth-ph_phv-premium-plus').is(':checked')) {
				JQ('#m098_tarif').text('Premium Plus');
			}

            if (JQ('#f_phth-ph_marktgarantie_1').is(':checked')) {
				JQ('#m098_marktgarantie').text('Ja');
			}

            if (JQ('#f_phth-ph_marktgarantie_0').is(':checked')) {
				JQ('#m098_marktgarantie').text('Nein');
			}

            ALL.setChkFlds(PHTH.type);
	}
	ALL.notifyHeight();
    },

    setPremium: function(data) {
        var r;
	BC.debug('PHTH.setPremium() for ' + PHTH.type, data, 64);
 	ALL.chkError(data);
	if (data.ERROR) {
	    return;
	}
        data.branch = PHTH.type;
        var b = JQ('#l_' + PHTH.type + '_brt2').length ? PHTH.type : PHTH.branch;
        ALL.setZWs(data);
	JQ.each(data, function(key, val) {
            r = key.match(/^([a-z\d]+)_([a-z]+)$/);
            if (! r) r = ['', '', ''];
	    if (key == 'DirA' && val && val.length) {
		PRIV.setDirAnfrage(val);
		return;
	    } else if (JQ('#f_' + b + '_' + key).length) {
		JQ('#f_' + b + '_' + key).text(val.str);
	    } else if (JQ('#r_' + b + '-' + r[2] + '_' + r[1]).length) {
                JQ('#r_' + b + '-' + r[2] + '_' + r[1]).text(val.str);
            }
	    if (key == 'net0_bh' && val.val) {
		// Sonderfall Einmalprämie Bauherrenhaftpflicht
		JQ('#li_phth_net0').show();
		JQ('#li_phth_vst0').show();
		JQ('#li_phth_brt0').show();
	    } else if (key == 'net0_bh') {
		JQ('#li_phth_net0').hide();
		JQ('#li_phth_vst0').hide();
		JQ('#li_phth_brt0').hide();
	    }
	    if (key == 'mpr2' && val.val) {
		JQ('#l_' + b + '_net2').text('Jährliche Nettoprämie Haftpflichtversicherung (Mindestprämie!):');
	    } else if (key == 'mpr2') {
		JQ('#l_' + b + '_net2').text('Jährliche Nettoprämie Haftpflichtversicherung:');
	    }
	    if (key == 'brt1' && val.str) {
		ALL.chgProduct(b, val.str);
	    }
	    if (key == 'net0' && val.val) {
		JQ('#l_all_' + b).html('Haftpflichtversicherung:<br/>(ohne Einmalbeitrag von zusätzlich ' + val.str + ')');
	    } else if (key == 'net0') {
		JQ('#l_all_' + b).text('Haftpflichtversicherung:');
	    }
	});
	ALL.notifyHeight();
    }
};
